const appId = 'wx9b3ada98e020c31b';
export default appId;
